import { useTranslation } from "react-i18next";

import { getFacilityCategoryLabel, type HaNFacilityCategory } from "@lib/logic";
import { IconButton } from "@molecules";

type FacilityCategoryHeaderProps = {
  category: HaNFacilityCategory;
  onBack: () => void;
};

export const FacilityCategoryHeader = ({ category, onBack }: FacilityCategoryHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2 px-3 pb-1 pt-3">
      <IconButton
        size="small"
        aria-label={t("workplace:GoBack")}
        iconButton="tertiary"
        icon="caretLeft"
        onClick={onBack}
      />
      <h3 className="truncate font-semibold">{getFacilityCategoryLabel(category, t)}</h3>
    </div>
  );
};
